<template>
  <div class="datatable table-events-plan">
    <div class="dt-content" :class="(getListEvent.length === 0 && !showOnModal) ? 'opacity-04' : null">
      <div class="dt-header" id="dt-header">
        <div class="header-col col-event-name"
             :style="{ width: columnWidth.eventName.size ? (columnWidth.eventName.size + 'px') : '12%' }"
             @click="setSortOption('eventNameSorting')" id="eventName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('eventName', $event)"></div>
              <div class="content no-select">
                name
                <Icon name="sort" class="sort-icon " v-if="this.pagingObj.sortType != 'eventNameSorting'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'eventNameSorting' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'eventNameSorting' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.prefDate.size ? (columnWidth.prefDate.size + 'px') : '9%' }"
             @click="setSortOption('prefDate')" id="prefDate">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('prefDate', $event)"></div>
              <div class="content no-select">
                DATE
                <span>
                <Icon name="sort" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType != 'prefDate'"></Icon>
                <Icon name="sort-up" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType == 'prefDate' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType == 'prefDate' && !this.pagingObj.sortReverse"></Icon>
              </span>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.projPart.size ? (columnWidth.projPart.size + 'px') : '5%' }"
             @click="setSortOption('projPart')" id="projPart">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('projPart', $event)"></div>
              <div class="content no-select">
                PART
                  <Icon name="sort" class="sort-icon sort-icon-small-text"
                        v-if="this.pagingObj.sortType != 'projPart'"></Icon>
                  <Icon name="sort-up" class="sort-icon sort-icon-small-text"
                        v-if="this.pagingObj.sortType == 'projPart' && this.pagingObj.sortReverse"></Icon>
                  <Icon name="sort-down" class="sort-icon sort-icon-small-text"
                        v-if="this.pagingObj.sortType == 'projPart' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.fullAddress.size ? (columnWidth.fullAddress.size + 'px') : '19%' }"
             @click="setSortOption('fullAddress')" id="fullAddress">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('fullAddress', $event)"></div>
              <div class="content no-select">
                FULL ADDRESS
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'fullAddress'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'fullAddress' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'fullAddress' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.building.size ? (columnWidth.building.size + 'px') : '7%' }"
             @click="setSortOption('building')" id="building">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('building', $event)"></div>
              <div class="content no-select">
                Building
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'building'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'building' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'building' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.eventLocation.size ? (columnWidth.eventLocation.size + 'px') : '7%' }"
             @click="setSortOption('eventLocation')" id="eventLocation">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('eventLocation', $event)"></div>
              <div class="content no-select small-text-margin">
                LOCATION
                <Icon name="sort" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType != 'eventLocation'"></Icon>
                <Icon name="sort-up" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType == 'eventLocation' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon sort-icon-small-text"
                      v-if="this.pagingObj.sortType == 'eventLocation' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.startTime.size ? (columnWidth.startTime.size + 'px') : '7%' }"
             @click="setSortOption('startTime')" id="startTime">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('startTime', $event)"></div>
              <div class="content no-select">
                start
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'startTime'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'startTime' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'startTime' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.duration.size ? (columnWidth.duration.size + 'px') : '5%' }"
             @click="setSortOption('duration')" id="duration">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('duration', $event)"></div>
              <div class="content no-select">
                dur
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'duration'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'duration' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'duration' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col" :style="{ width: columnWidth.endTime.size ? (columnWidth.endTime.size + 'px') : '7%' }"
             @click="setSortOption('endTime')" id="endTime">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('endTime', $event)"></div>
              <div class="content no-select">
                end
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'endTime'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'endTime' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'endTime' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.timeZone.size ? (columnWidth.timeZone.size + 'px') : '4%' }"
             @click="setSortOption('timeZone')" id="timeZone">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('timeZone', $event)"></div>
              <div class="content no-select">
                tz
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'timeZone'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.contactName.size ? (columnWidth.contactName.size + 'px') : '9%' }"
             @click="setSortOption('contactName')" id="contactName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('contactName', $event)"></div>
              <div class="content no-select small-text-margin">
                CONTACT
                  <Icon name="sort" class="sort-icon sort-icon-small-text"
                        v-if="this.pagingObj.sortType != 'contactName'"></Icon>
                  <Icon name="sort-up" class="sort-icon sort-icon-small-text"
                        v-if="this.pagingObj.sortType == 'contactName' && this.pagingObj.sortReverse"></Icon>
                  <Icon name="sort-down" class="sort-icon sort-icon-small-text "
                        v-if="this.pagingObj.sortType == 'contactName' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col" :style="{ width: columnWidth.action.size ? (columnWidth.action.size + 'px') : '9%' }"
             id="action">
          <div class="header-container">
            <div class="crop">
              <div class="content no-select">
                {{ viewMode === 'Client' ? '' : '' }}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div id="dt-body" class="dt-body" :class="scrunch ? 'scrunch' : null">
        <div v-if="(getListEvent.length !== 0 || showOnModal) && !getLoading">
          <div v-for="(itemNewEvent, index) in parentEvent" :key="itemNewEvent.id">
            <DataTableRowEditMode :showOnModal="showOnModal" :editable="editable"
                :viewMode="viewMode" :editEventAdmin="editEventAdmin"
                :eventStatus="eventStatus" :index="index" :item="itemNewEvent"
                :key="index"></DataTableRowEditMode>
          </div>
        </div>
        <!--template v-for="(item, index) in events">
                        <DataTableRow :index="index" :item="item"/>
                      </template -->
      </div>
    </div>
    <div class="dt-footer" v-if="getListEvent.length !== 0 && !showOnModal">
      <!--<DtPaging v-if="!showOnModal && !showRelatedEvent" v-on:CHANGE_PAGING_OPTIONS="changePagingOptions"
                :currentPage="pagingObj.currentPage"
                :itemsPerPage="pagingObj.itemsPerPage" :totalItems="totalItems"></DtPaging>-->
    </div>
    <!-- Map must be visible to get data from Bing Map API -->
    <div id="myMap" style="position:relative; width:1px ; height:1px;"></div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/sort';
  import 'vue-awesome/icons/sort-up';
  import 'vue-awesome/icons/sort-down';

  import Icon from 'vue-awesome/components/Icon';
  import {mapGetters, mapActions, mapMutations} from 'vuex';

  import DataTableRow from './DataTableRow';
  import DataTableRowEditMode from './DataTableRowEditMode';
  import DtPaging from './DtPaging';
  import consts from '../../_consts';
  import * as _ from 'lodash';

  // const _ = require('lodash');
  export default {
    name: 'dataTable',
    components: {
      Icon,
      DataTableRow,
      DataTableRowEditMode,
      DtPaging
    },
    data () {
      return {
        scrunch: false,
        // START: paging
        pagingObj: {
          currentPage: 1,
          itemsPerPage: '25',
          totalItems: this.totalItems,
          sortType: 'isChangeOrder',
          sortReverse: false
        },
        // END: paging
        arrStatus: [],
        resizing: false,
        messages: [], // TODO ws change later
        programId: null
      };
    },
    props: {
      eventStatus: {
        type: String,
        default: ''
      },
      viewMode: {
        type: String,
        default: 'Client'
      },
      editable: {
        type: Boolean,
        default: false
      },
      showOnModal: {
        type: Boolean,
        default: false
      },
      dataOnModal: {
        type: Object
      },
      editEventAdmin: {
        type: Boolean,
        default: false
      },
      parentEvent: {
        type: Array,
        default: []
      }
    },
    computed: {
      allowEdit () {
        this.editable = false;
      },
      totalItems () {
        return this.countEventByStatus(this.eventStatus);
      },
      listEventStatus () {
        return this.getListEvenStatus;
      },
      columnWidth () {
        return this.getColumnWidth;
      },
      ...mapGetters({
        getListEvent: 'GETTERS_LIST_EVENT',
        countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
        getListEvenStatus: 'GETTERS_LIST_EVENT_STATUS',
        showRelatedEvent: 'GETTERS_SHOW_RELATED_EVENT',
        getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH',
        getLockIds: 'GETTERS_GET_LOCK_IDS',
        getErrorCodes: 'GETTERS_ERROR_CODES',
        getLoading: 'GETTERS_IS_LOADING'
      })
    },
    methods: {
      changePagingOptions: function (pagingObj) {
        this.pagingObj.currentPage = pagingObj.currentPage;
        this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
        this.pagingObj.totalItems = pagingObj.totalItems;
      },
      setSortOption: function (sortType) {
        if (!this.resizing) {
          this.pagingObj.sortType = sortType;
          this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
        }
      },
      getListEventParams: function () {
        if (this.eventStatus === '') {
          this.arrStatus = this.getListEvenStatus;
        } else {
          this.arrStatus = [this.eventStatus.toUpperCase()];
        }
        return {
          userId: Number(localStorage.getItem(consts.LOCAL_STORE.userId)),
          status: this.arrStatus,
          options: this.pagingObj,
          clientId: Number(localStorage.getItem(consts.LOCAL_STORE.clientId)),
          programId: this.programId
        };
      },
      changeColumnWidth: function (colName, mouseDownEvent) {
        this.resizing = true;
        let vueApp = this;
        // get current mouse position
        let shiftX = mouseDownEvent.clientX;
        // header width
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth = dtHeaderEl.getBoundingClientRect().width;
        // get maximum width
        let maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
        let newWidth = maxLeft;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        function onMouseMove (event) {
          // new position
          let bufferPx = event.clientX - shiftX;
          let newHeaderWidth = headerWidth + bufferPx;

          if (bufferPx < 0 && (maxLeft - Math.abs(bufferPx)) < 20) {
            newWidth = 20;
            newHeaderWidth = headerWidth - (maxLeft - 20);
          } else {
            newWidth = maxLeft + bufferPx;
          }

          // save data
          vueApp.saveColumnWidth({
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: colName,
            newWidth: newWidth.toFixed(2)
          });
        }

        function onMouseUp () {
          document.removeEventListener('mouseup', onMouseUp);
          document.removeEventListener('mousemove', onMouseMove);
          setTimeout(() => {
            vueApp.resizing = false;
          }, 50);
        }
      },
      receiveOnlineGuest (frame) {
        // console.log(typeof JSON.parse(frame.body))
        console.log(frame.body);
        // this.setOnlineGuest(JSON.parse(frame.body))
      },
      isLocked (eventId) {
        return this.getLockIds.eventIds.indexOf(eventId.toString()) !== -1;
      },
      changeTableSrcollable (isWidthPercent) {
        // if screen resolution < 1360px convert table to pixel
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth;
        if (dtHeaderEl) {
          headerWidth = dtHeaderEl.getBoundingClientRect().width;
        }
        let arrCol = [
          {
            colName: 'eventName',
            newWidth: 150
          },
          {
            colName: 'prefDate',
            newWidth: 110
          },
          {
            colName: 'projPart',
            newWidth: 65
          },
          {
            colName: 'fullAddress',
            newWidth: 330
          },
          {
            colName: 'building',
            newWidth: 85
          },
          {
            colName: 'eventLocation',
            newWidth: 85
          },
          {
            colName: 'startTime',
            newWidth: 85
          },
          {
            colName: 'duration',
            newWidth: 65
          },
          {
            colName: 'endTime',
            newWidth: 85
          },
          {
            colName: 'timeZone',
            newWidth: 50
          },
          {
            colName: 'contactName',
            newWidth: 110
          },
          {
            colName: 'action',
            newWidth: 120
          }
        ];
        if (document.body.clientWidth < 1200) {
          let newHeaderWidth = 1200;
          let tbHeaderId = 'dt-header';
          let tbBodyId = 'dt-body';
          let dtHeaderEl = document.getElementById(tbHeaderId);
          let dtBodyEl = document.getElementById(tbBodyId);
          dtHeaderEl.style.width = '1200px';
          dtBodyEl.style.width = '1200px';
          arrCol.forEach((element) => {
            this.saveColumnWidth({
              headerWidth: headerWidth,
              newHeaderWidth: newHeaderWidth,
              colName: element.colName,
              newWidth: element.newWidth
            })
          })
        } else {
          let tbHeaderId = 'dt-header';
          let tbBodyId = 'dt-body';
          let dtHeaderEl = document.getElementById(tbHeaderId);
          let dtBodyEl = document.getElementById(tbBodyId);
          if (dtHeaderEl) {
            dtHeaderEl.style.width = 'unset';
          }
          if (dtBodyEl) {
            dtBodyEl.style.width = 'unset';
          }
          arrCol.forEach((element) => {
            this.mutationSetColWidth({
              colName: element.colName,
              newWidth: 0,
              isTableUser: false
            })
          })
        }
      },
      ...mapActions({
        getEventList: 'ACTION_GET_EVENT_LIST',
        saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH',
        resetColumnSize: 'ACTION_RESET_COLUMN_SIZE',
        lockEvent: 'ACTION_LOCK_EVENT',
        lockEventList: 'ACTION_LOCK_EVENT_LIST',
        removeEventFromUI: 'ACTION_REMOVE_EVENT_FROM_UI'
      }),
      ...mapMutations({
        mutationSetColWidth: 'MUTATION_SAVE_COLUMN_WIDTH'
      })
    },
    beforeMount () {
      if (this.showOnModal === false) {
        this.getEventList(this.getListEventParams());
        localStorage.setItem(consts.LOCAL_STORE.pagingOptions, JSON.stringify(this.getListEventParams()));
      }
      // reset column size
      this.resetColumnSize();
    },
    mounted () {
      const that = this;
      this.changeTableSrcollable();
      this.$root.$on('RELOAD_EVENT_LIST', (programId) => {
        that.programId = programId;
        that.getEventList(that.getListEventParams());
      });
    },
    created () {
      let readOnly = localStorage.getItem(consts.LOCAL_STORE.readOnly);
      this.editable = !(readOnly === 'true');
      window.addEventListener('resize', _.debounce((event) => {
        if (document.body.clientWidth < 1200) {
          this.changeTableSrcollable();
        } else {
          this.changeTableSrcollable(true);
        }
      }, 100));
    },
    watch: {
      pagingObj: {
        handler: function () {
          this.getEventList(this.getListEventParams());
          localStorage.setItem(consts.LOCAL_STORE.pagingOptions, JSON.stringify(this.getListEventParams()));
        },
        deep: true
      },
      listEventStatus: {
        handler: function () {
          if (!this.$store.getters.GETTERS_SHOW_RELATED_EVENT) {
            this.getEventList(this.getListEventParams());
          }
        }
      },
      eventStatus: {
        handler: function () {
          if (!this.$store.getters.GETTERS_SHOW_RELATED_EVENT) {
            this.getEventList(this.getListEventParams());
          }
          this.changeTableSrcollable();
        }
      },
      getErrorCodes: function () {
        if (this.getErrorCodes !== null) {
          let modalData = {
            action: consts.modalAction.submitAllError,
            data: this.getErrorCodes
          };
          this.$modal.show('eventModal', modalData);
        }
      }
    }
  };
</script>

<style lang="less">
  @import '../../styles/variables.less';
  @import '../../styles/aduro/_color.less';
  .datatable {
    font-size: 14px;
    margin: 15px 0px 15px 0;
    .dt-list-status {
      height: 37px;
      background-color: @grey-5;
      .btn-status {
        height: 37px;
        width: 37px;
        float: left;
        vertical-align: middle;
        display: grid;
        padding: 8px 0;
        &:hover {
          cursor: pointer;
          background-color: @white;
        }
        &.active {
          background-color: @white;
          .line {
            background-color: @black;
          }
        }
        .line {
          width: 18px;
          background: @grey-3;
          height: 3px;
          margin: 0 auto;
        }
        .scrunch {
          height: 2px;
        }
      }
    }

    /* FOR IE */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .dt-list-status {
        .btn-status {
          .line {
            margin-bottom: 3px;
          }
        }
      }
    }

    .dt-content {
      overflow-x: scroll;
      overflow-y: hidden;
      .dt-header {
        font-size: 12px;
        height: 40px;
        line-height: 16px;
        background-color: @grey-1;
        font-family: "Open Sans", sans-serif;
        letter-spacing: 0.1px;
        padding-top: 12px;
        color: @white;
        .header-col {
          float: left;
          height: 16px;
          overflow: hidden;
          padding-left: 10px;
          text-transform: uppercase;
          word-break: break-all;
          &:hover {
            cursor: pointer;
          }
          &:last-child {
            // border-right: solid 1px @grey-3;
          }
          .sort-icon {
            vertical-align: middle;
            width: 6px;
            height: 10px;
            margin: 5px;
          }
        }
        .col-event-name {
          padding-left: 30px;
        }
      }
      .dt-body {
        clear: both;
        background-color: @grey-5;
        &.scrunch {
          .dt-row-detail {
            height: 40px;

            .body-col-address-bing{
              height: 200px;
            }
            .body-col {
              height: 40px;
              line-height: 40px;
            }
          }
        }
        .dt-row {
          /*max-width: 100%;*/
        }
        .dt-row-detail {
          max-width: 100%;
          height: 56px;
          border-radius: 1px;
          background-color: #FFFFFF;
          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
          margin-top: 1px;


          /*&.active {
            background-color: @white;
            .data-table-row-edit-mode-text {
              background-color: @white;
              .multiselect__input {
                background-color: @white;
              }
              .display-time {
                background-color: @white;
                width: 100%;
                padding: 0;
                border: none;
              }
            }
            .col-contact {
              background-color: @white;
              // margin-left: 5px;
              .multiselect__input {
                background-color: @white;
              }
            }
          }
          &:hover {
            background-color: @grey-5;
            box-shadow: 0 3px 6px 0 @grey-5;
            .data-table-row-edit-mode-text {
              background-color: @grey-5;
              .multiselect__input {
                background-color: @grey-5;
              }
              .display-time {
                background-color: @grey-5;
              }
            }
            .col-contact {
              background-color: @grey-5;
              .multiselect__tags {
                background-color: @grey-5;
              }
              .multiselect__single {
                background-color: @grey-5;
              }
              .multiselect__input {
                background-color: @grey-5;
              }
            }
          }*/


          .body-col {
            float: left;
            height: 50px;
            line-height: 50px;
            padding-left: 5px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            font-size: 12px;

            .address-error {
              border: 1px solid @red-40;
            }

            .address-error-message {
              position: relative;
              bottom: 16px;
              font-size: x-small;
              color: @red-40;
            }

            .icon-wrapper {
              width: 32px;
              height: 32px;
              border-radius: 4px;
              display: inline-block;
              vertical-align: middle;
              background-color: @light-blue;
            }

            &.overflow-show {
              overflow: visible;
              .data-table-row-edit-mode-text {
                z-index: unset;
                width: 100%;
                .display-time {
                  background-color: @grey-5;
                  width: 100% !important;
                  padding: 0 !important;
                  border: none !important;
                }
              }
              .col-contact {
                z-index: unset;
                width: 100%;
                // margin-left: 5px;
              }
            }
            .row-detail-icon {
              vertical-align: middle;
              margin-left: 2px;
              margin-bottom: 2px;
              color: @white;
              background-color: @light-blue;
              padding: 3px;
              border-radius: 6px;
              &:hover {
                cursor: pointer;
              }
            }
            .row-detail-icon-exclamation-circle {
              height: 14px;
              width: 14px;
              border-radius: 6px;
              padding: 0;
              color: @blue;
              background-color: @white;
              overflow: visible;
            }
            .pref-date-body-col {
              height: 100%;
              color: @black-3;
              display: flex;
              align-items: center;

              &.place-holder{
                color: @text-10;
              }
            }
            .action-change-order {
              color: @blue;
              font-family: @font-family-main;
              font-size: 10px;
              font-weight: 600;
              line-height: 14px;
              text-transform: uppercase;
              &:hover {
                cursor: pointer;
              }
            }
          }
          .event-name {
            // font-weight: 600;
            // color: @blue;
            .event-icon {
              vertical-align: middle;
              margin-right: 5px;
            }
            .client-name {
              // position: absolute;
              color: @black;
              font-family: @font-family-main;
              font-size: 10px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              height: 15px;
              padding: 0;
              margin-top: 10px;
              line-height: 10px;
              margin-left: 20px;
              // margin-top: -15px;
            }
            .col-end-time{
              .place-holder{
                color: @text-10;
              }
            }
            .name {
              display: flex;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              margin-top: -13px;
              font-family: @font-family-main;
              height: 25px;
              color: #1D1D1D;
              font-size: 12px;
              line-height: 25px;
              .icon-expand {
                width: 20px;
                float: left;
                margin-right: 8px;

                &:hover {
                  cursor: pointer;
                }
              }
              input {
                font-family: @font-family-main;
                font-size: 12px;
                margin-left: 4px;
              }
            }
          }
        }

        .dt-row-item-detail {
          clear: both;
          .item-detail-header {
            text-transform: uppercase;
            line-height: 34px;
            padding: 0 10px;
            height: 34px;
            background-color: #606060;
            color: #FFFFFF;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            letter-spacing: 0.1px;
          }

          .item-detail-body {
            background-color: @white;
            padding: 20px 10px 15px 20px;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
            box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
            .row-detail-icon-exclamation-circle {
              height: 13px;
              width: 13px;
              border-radius: 6px;
              padding: 0;
              color: @blue;
              background-color: @white;
              overflow: visible;
            }
            .icon-alert {
              padding: 2px 0px 0px 22px;
            }
            .text-alert {
              font-family: @font-family-main;
              font-size: 14px;
              padding: 0 20px 0 15px;
              .alert-note {
                // margin-left: -15px;
              }
            }
            .notes-field {
              margin-top: 20px;
              &:first-child {
                margin-top: 0;
              }
              .text-label {
                font-size: 12px;
                text-transform: capitalize;
                line-height: 18px;
                font-family: @font-family-main;
                color: @black-1;
                .label-address {
                  color: @grey-3;
                }
              }
              .text-value {
                textarea {
                  width: 100%;
                  border-radius: 3px;
                  border: solid 1px @grey-4;
                  padding: 5px 10px;
                  &.custom-notes {
                    height: 55px;
                    padding-left: 14px;
                    color: @black;
                  }
                  &.additional-comments {
                    height: 95px;
                    padding-left: 14px;
                    color: @black;
                  }
                }
              }
            }
            .text-contact {
              margin-bottom: 20px;
              margin-right: 10px;
              .label {
                color: @black-1;
                font-family: @font-family-main;
                font-size: 12px;
                text-transform: capitalize;
                line-height: 18px;
              }
              .contactName {
                line-height: 31px;
              }
              // &:first-child {
              //   margin-top: 0;
              // }
            }
            .func-group {
              // text-align: right;
              // position: absolute;
              // bottom: 0;
              // right: 20px;
              button {
                font-size: 14px;
                height: 39px;
                // margin-left: 10px;
                font-family: @font-family-main;
                text-transform: uppercase;
                .func-icon {
                  width: 18px;
                  height: 18px;
                  color: @white;
                  float: left;
                  // margin-top: 2px;
                }
              }
              .grey-3 {
                color: @grey-3;
              }
            }
          }
        }
      }

      .header-col {
        .header-container {
          position: relative;
        }
        .crop {
          /*height: 37px;*/
          transition: all 0.25s;
          cursor: pointer;
        }

        .crop .crop-line {
          position: absolute;
          transition: all 0.25s;
        }
        .crop:hover .crop-line {
          border-color: @grey-3;
        }
        .crop .crop-top-line {
          top: 0;
          left: 0;
          right: 0;
          height: 5px; /* 5px for the mouse cursor update size */
          border-top: 1px solid @grey-3;
          cursor: n-resize;
        }
        .crop .crop-bottom-line {
          bottom: 0;
          left: 0;
          right: 0;
          height: 5px; /* 5px for the mouse cursor update size */
          border-bottom: 1px solid @grey-3;
          cursor: s-resize;
        }
        .crop .crop-left-line {
          top: 0;
          left: 0;
          bottom: 0;
          width: 5px; /* 5px for the mouse cursor update size */
          border-left: 1px solid @grey-3;
          cursor: col-resize;
        }
        .crop .crop-right-line {
          top: 0;
          right: 0;
          bottom: 0;
          width: 5px; /* 5px for the mouse cursor update size */
          border-right: 1px solid @grey-3;
          cursor: col-resize;
        }
        .crop .crop-corner {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 2px;
          border: 1px solid #808080;
          background: #FFF;
          opacity: 0;
          transition: all 0.25s;
        }
        .crop .crop-top-left-corner {
          top: -3px;
          left: -3px;
          cursor: nw-resize;
        }
        .crop .crop-top-right-corner {
          top: -3px;
          right: -3px;
          cursor: ne-resize;
        }
        .crop .crop-bottom-left-corner {
          bottom: -3px;
          left: -3px;
          cursor: sw-resize;
        }
        .crop .crop-bottom-right-corner {
          bottom: -3px;
          right: -3px;
          cursor: se-resize;
        }
        .crop:hover .crop-corner {
          opacity: 1;
        }
      }
      .small-text {
        font-size: 10px;
        .small-text-margin {
          .first-line {
            position: absolute;
            top: -5px;
          }
          .second-line {
            position: absolute;
            top: 8px;
          }
          .icon-section {
            position: absolute;
            top: 1px;
            left: 50px;
          }
          // .icon-section-for-small-text{
          //   margin-left: 30px;
          // }
          // .sort-icon-small-text {
          // }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// DataTable.vue?e33c5f50